import React from 'react';
import { AutocompleteInput, ReferenceInput } from 'react-admin';
import { SUPPLIER } from './Order.string';

export default function SupplierAutoCompleteInput({
  onSelect,
}: {
  onSelect: (formData: any) => void;
}) {
  return (
    <ReferenceInput
      label={`${SUPPLIER.NAME}`}
      allowEmpty={true}
      variant='outlined'
      reference='suppliers'
      sort={{ field: 'name', order: 'ASC' }}
      filter={undefined}
      filterToQuery={(text) => ({ name: text })}
      source={'supplier.id'}
    >
      <AutocompleteInput
        optionText={'name'}
        source='supplierName'
        onSelect={onSelect}
      />
    </ReferenceInput>
  );
}
